<template>
  <div>
    <apollo-query
      :query='getTemplatesQuery'
      :variables='{nextToken, size, public:true}'
      @result='onLoadedTemplates'
      fetch-policy='cache-and-network'
      class="overflow-x-hidden grid grid-cols-2 md:grid-cols-4 gap-2">
      <template v-slot='{ result: { loading, error, data }, isLoading }'>
        <fill-loader v-if='loading && !data' />

        <button v-for='template in templates'
            :key='template.id'
            @click='onTemplate(template)'
            style='background-color: #4A5568'
            class='flex-none rounded my-1 text-center flex flex-col justify-start w-full'>

            <div class="relative w-full">
              <img :src='makeImageUrl(template)' class="object-contain w-full w-full h-48" loading="lazy" />
              <span v-for='tag in getTags(template)' :key='tag' class="absolute bottom-0 right-0 bg-blue-500 text-sm text-white p-1 rounded-lg shadow uppercase">
                {{tag}}
              </span>
            </div>

            <div class="p-1 text-gray-300 text-sm text-center w-full">{{template.title}}</div>

        </button>
      </template>
    </apollo-query>

    <div v-observe-visibility="{
         callback:loadMore,
         intersection:{
           rootMargin: '-20% 0px -60% 0px',
         }
       }">&nbsp;</div>

  </div>

</template>
<script>
import { uniqBy } from 'lodash';
//import ImageUploader from '@ui/molecules/ImageUploader.vue';
import { getTemplatesQuery } from '@/gql/Queries.js';
export default {
  inject: ['api'],
  components:{
  },
  data() {
    return {
      getTemplatesQuery,
      nextToken:'',
      size:100,
      image:'',
      previous:{},
      templates:[]
    }
  },
  mounted() {
    this.$ana.track({
      eventCategory:'ui',
      eventAction:'openCreateDialog'
    });
  },
  beforeDestroy() {
    this.$ana.track({
      eventCategory:'ui',
      eventAction:'closeCreateDialog'
    });
  },
  methods:{
    getTags(template) {
      return (template.tags||'').split(",").map( (t) => {
        return t.trim();
      }).filter( (t) => {
        return t.length > 0
      });
    },
    makeImageUrl(template) {
      return this.api.makeImageUrlEditor(template.thumbnailImage);
    },
    onTemplate(template) {
      this.$router.push({
        name:'template',
        params: {
          templateId: template.id
        }
      });
    },
    loadMore() {
      console.log('load more');
      if (this.previous && this.previous.getTemplates) {
        this.nextToken = this.previous.getTemplates.nextToken;
      }
    },
    onLoadedTemplates(data) {
      console.log('data', data);
      this.templates = uniqBy(this.templates.concat([...(data?.data?.getTemplates?.items ?? [])]), ({id}) => {
        return id;
      });;
      this.previous = data.data;
    }

  }
}
</script>
